// extracted by mini-css-extract-plugin
module.exports = {"titleVariant":"Title_titleVariant__uIs_2","title":"Title_title__Qhvrt"};